module.exports = __webpack_public_path__ + "static/media/boardroom.f85d6a9f.png";